import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#041a0f] via-[#03140c] to-[#010604] text-white pt-32 pb-20 px-6 font-sans relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 left-1/4 -translate-x-1/2 w-[500px] h-[500px] bg-gradient-to-tr from-gold-900/10 to-transparent rounded-full filter blur-[140px] pointer-events-none"></div>
      
      <div className="max-w-4xl mx-auto relative z-10">
        <h1 className="text-4xl md:text-5xl font-serif font-black text-[#eddca6] tracking-widest mb-12 border-b border-[#eddca6]/20 pb-6">
          Privacy Policy
        </h1>
        
        <div className="space-y-10 text-white/80 font-light leading-relaxed">
          <section className="space-y-4">
            <h2 className="text-xl md:text-2xl font-serif text-[#eddca6] tracking-wider">1. Introduction</h2>
            <p>
              Welcome to Chirayil Gold and Diamonds. We respect your privacy and are committed to protecting your personal data. This privacy policy will inform you as to how we look after your personal data when you visit our website (regardless of where you visit it from) and tell you about your privacy rights and how the law protects you.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl md:text-2xl font-serif text-[#eddca6] tracking-wider">2. Data We Collect</h2>
            <p>
              We may collect, use, store and transfer different kinds of personal data about you which we have grouped together follows:
            </p>
            <ul className="list-disc pl-5 space-y-2 text-white/70">
              <li><strong>Identity Data:</strong> includes first name, last name, username or similar identifier.</li>
              <li><strong>Contact Data:</strong> includes billing address, delivery address, email address and telephone numbers.</li>
              <li><strong>Transaction Data:</strong> includes details about payments to and from you and other details of products and services you have purchased from us.</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl md:text-2xl font-serif text-[#eddca6] tracking-wider">3. How We Use Your Data</h2>
            <p>
              We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:
            </p>
            <ul className="list-disc pl-5 space-y-2 text-white/70">
              <li>Where we need to perform the contract we are about to enter into or have entered into with you.</li>
              <li>Where it is necessary for our legitimate interests (or those of a third party) and your interests and fundamental rights do not override those interests.</li>
              <li>Where we need to comply with a legal or regulatory obligation.</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl md:text-2xl font-serif text-[#eddca6] tracking-wider">4. Data Security</h2>
            <p>
              We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used or accessed in an unauthorised way, altered or disclosed. In addition, we limit access to your personal data to those employees, agents, contractors and other third parties who have a business need to know.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl md:text-2xl font-serif text-[#eddca6] tracking-wider">5. Contact Us</h2>
            <p>
              If you have any questions about this privacy policy or our privacy practices, please contact us at:
              <br />
              <strong>Email:</strong> info@chirayilgoldanddiamonds.com
              <br />
              <strong>Phone:</strong> +91 9605155088
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
